export const categories = [
  {
    slug: 'zhumian-fangsong',
    name: '助眠放松',
    description: '专为失眠人群整理的助眠ASMR资源，帮助你快速入眠、缓解焦虑，享受深度放松的听觉体验。',
    icon: 'ri-moon-line',
    imageSeq: 'cat-sleep',
  },
  {
    slug: 'bai-zaoyin',
    name: '白噪音',
    description: '精选白噪音、粉红噪音、自然音效平台，营造专注与放松的氛围，适合工作学习与冥想场景。',
    icon: 'ri-speaker-line',
    imageSeq: 'cat-noise',
  },
  {
    slug: 'eryu-asmr',
    name: '耳语ASMR',
    description: '推荐最优质的耳语、轻声细语类ASMR频道，体验极致的颅内高潮与温柔声线带来的愉悦感。',
    icon: 'ri-mic-line',
    imageSeq: 'cat-whisper',
  },
  {
    slug: 'jiaose-banyan',
    name: '角色扮演',
    description: '汇集各类角色扮演ASMR创作者，从医生问诊到理发店体验，沉浸式场景让你身临其境。',
    icon: 'ri-user-voice-line',
    imageSeq: 'cat-roleplay',
  },
  {
    slug: 'chibo-jujueyin',
    name: '吃播咀嚼音',
    description: '整理最佳咀嚼音、吃播ASMR频道，酥脆、软糯、多汁的声音满足你的听觉食欲。',
    icon: 'ri-restaurant-line',
    imageSeq: 'cat-eating',
  },
  {
    slug: 'chufa-yin',
    name: '触发音',
    description: '精选敲击、刮擦、翻页等触发音ASMR资源，多种声音刺激带来极致的放松与满足感。',
    icon: 'ri-fingerprint-line',
    imageSeq: 'cat-trigger',
  },
  {
    slug: 'zonghe-pingtai',
    name: '综合平台',
    description: '一站式ASMR综合平台推荐，涵盖多种类型的ASMR内容，满足你对ASMR网站的所有需求。',
    icon: 'ri-global-line',
    imageSeq: 'cat-platform',
  },
];